<template>
  <div>
    <div class="left_wrap">
      <Introduce></Introduce>
      <Promotion></Promotion>
      <NoticeList
        :clickHandler="clickHandler"
        :isAdmin="isAdmin">
      </NoticeList>
    </div>
    <div class="right_wrap" v-if="viewSample">
      <SamplePage></SamplePage>
      <SampleVideo></SampleVideo>
    </div>
    <NoticeDetail :closeHandler="closeHandler" v-if="isShow"
      :notice="notice"></NoticeDetail>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { isLogin, getInfo } from '@/assets/func'

  import NoticeList from './NoticeList'
  import NoticeDetail from './NoticeDetail'
  import Introduce from './Introduce'
  import Promotion from './Promotion'
  import SamplePage from './SamplePage'
  import SampleVideo from './SampleVideo'

  export default {
    name: 'main_screen',
    components: {
      Introduce,
      NoticeDetail,
      NoticeList,
      Promotion,
      SamplePage,
      SampleVideo
    },
    data () {
      return {
        uid: '',
        notice: {},
        isShow: false,
        isAdmin: false
      }
    },
    methods: {
      ...mapActions([
        'getNoticeRequest'
      ]),
      clickHandler (content) {
        this.openHandler()
        this.notice = content
      },
      closeHandler () {
        this.isShow = false
      },
      openHandler () {
        this.isShow = true
      }
    },
    computed: {
      viewSample () {
        return !(this.uid === '1108123070')
      }
    },
    created () {
      if (!isLogin()) {
        this.$router.push('/')
      } else {
        this.uid = getInfo().uid
        this.getNoticeRequest()
      }
    },
    mounted () {
      document.body.scrollTop = 0
      let userType = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_u')))).cust_knd
      if (userType === 'S') {
        this.isAdmin = true
      }
    }
  }
</script>

<style scoped>
  .top_wrapper {
    margin-bottom: 10px;
  }
  .left_wrap, .right_wrap {
    display: inline-block;
    width: calc(50% - 5px);
    vertical-align: top;
  }
  .right_wrap {
    margin-left: 5px;
  }
  .introduce, .promo, .example_mov, .notice {
    width: 100%;
    background: #fff;
    border-radius: 7px;
    border: 1px solid #d1dce3;
  }
  
  .sample_render {
    background: #fff;
    border-radius: 7px;
    border: 1px solid #d1dce3;
  }
  .promo {
    margin-top: 10px;
    min-height: 70px;
  }

  .notice {
    min-height: 130px;
    vertical-align: middle;
    margin-top: 10px;
  }
  .example_mov {
    margin-top: 10px;
    margin-bottom: 5px;
    /* background: rgb(231, 231, 231) !important; */
    text-align: center;
  }
  @media screen and (max-width: 1080px){
    .top_wrapper {
      display: block;
    }
    .left_wrap, .right_wrap {
      width: 100%;
      margin-bottom: 0;
    }
    .right_wrap {
      margin-top: 10px;
      margin-left: 0;
    }
    .introduce {
      margin-top: 10px;
    }
  }

  @media screen and (max-width: 800px){
    .notice, .introduce, .promo, .sample_render, .example_mov {
      width: calc(100% - 10px);
      margin-left: 5px; 
      margin-right: 5px;
    }
    .sample_render {
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// MainScreen.vue?1cc6b8cf